import axios from "axios";
import {
    categoriesUrl,
    linksUrl,
    archiveUrl,
    authenticateUrl,
    statsUrl,
    twitterHandleUrl
} from "./urls";
import authService from "./authService";

const Headers = {
  auth: () => ({
    Authorization: "Bearer" + authService.getJwtToken()
  }),
  contentTypeJson: { "Content-Type": "application/json" }
};

export function configureHttp(beforeReq, afterReq, errorHandler) {
  axios.interceptors.request.use(
    function(config) {
      beforeReq();
      return config;
    },
    function(error) {
      beforeReq();
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function(response) {
      afterReq();
      return response;
    },
    function(error) {
      afterReq();
      errorHandler(error);
      return Promise.reject(error);
    }
  );
}

export const http = {
  authenticate(login, password) {
    const payload = JSON.stringify({ login, password });
    return axios({
      url: authenticateUrl,
      method: "POST",
      data: payload,
      headers: { ...Headers.contentTypeJson }
    }).then(result => result.data.token);
  },

  loadCategories() {
    return this.fetch(categoriesUrl, "Cannot load categories: ");
  },

  addCategory(categoryName, refreshLinks) {
    return axios({
      url: categoriesUrl,
      method: "POST",
      data: JSON.stringify({ name: categoryName }),
      headers: { ...Headers.contentTypeJson, ...Headers.auth() }
    }).then(() => {
      refreshLinks();
    });
  },

  updateCategory(category, refresh) {
        return axios({
            url: categoriesUrl,
            method: "PUT",
            data: JSON.stringify(category),
            headers: { ...Headers.contentTypeJson, ...Headers.auth() }
          }).then(() => {
            refresh();
          }).catch(error => {
            alert(`Cannot update ${category.name}, see console for full error.`);
            console.error(`Cannot update ${category.name}. Err: ${error}`);
          });
  },
    
  removeCategory(categoryId, refreshLinks) {
    axios({
      url: `${categoriesUrl}/${categoryId}`,
      method: "DELETE",
      headers: { ...Headers.auth() }
    }).then(() => {
      refreshLinks();
    });
  },

  categoryUp(categoryId, refreshLinks) {
    axios({
      url: `${categoriesUrl}/${categoryId}/up`,
      method: "POST",
      headers: { ...Headers.auth() }
    }).then(() => {
      refreshLinks();
    });
  },

  categoryDown(categoryId, refreshLinks) {
    axios({
      url: `${categoriesUrl}/${categoryId}/down`,
      method: "POST",
      headers: { ...Headers.auth() }
    }).then(() => {
      refreshLinks();
    });
  },

  cloneLast(categoryId, refreshLinks) {
    axios({
      url: `${categoriesUrl}/${categoryId}/clone`,
      method: "POST",
      headers: { ...Headers.auth() }
    }).then(() => {
      refreshLinks();
    });
  },

  updateLink(linkData, refreshLinks) {
    axios({
      url: `${linksUrl}`,
      method: "PUT",
      data: JSON.stringify({
        id: linkData.get("id"),
        url: linkData.get("url"),
        title: linkData.get("title"),
        author: linkData.get("author"),
        twitterHandle: linkData.get("twitterHandle"),
        description: linkData.get("description"),
        alsoInIssue: linkData.get("alsoInIssue")
      }),
      headers: { ...Headers.contentTypeJson, ...Headers.auth() }
    })
      .then(() => {
        refreshLinks();
      })
      .catch(error => {
        alert(
          `Cannot update ${linkData.get("title")}, see console for full error.`
        );
        console.error(`Cannot update ${linkData.get("title")}. Err: ${error}`);
      });
  },

  deleteLink(linkId, refreshLinks) {
    axios({
      url: `${linksUrl}/${linkId}`,
      method: "DELETE",
      headers: { ...Headers.auth() }
    })
      .then(() => {
        refreshLinks();
      })
      .catch(error => {
        alert(`Cannot remove link, see console for full error.`);
        console.error(`Cannot remove link. Err: ${error}`);
      });
  },

  addLink(categoryId, newLink, handleAddLink) {
    axios({
      url: `${categoriesUrl}/${categoryId}`,
      method: "POST",
      data: JSON.stringify({
        url: newLink
      }),
      headers: { ...Headers.contentTypeJson, ...Headers.auth() },
      responseType: "json"
    })
      .then(response => response.data)
      .then(data => handleAddLink(data))
      .catch(error => {
        var responseObj = JSON.stringify(error.response, null, 4);
        alert(
          `Cannot add link ${newLink}. Response text: ${error.response.data}`
        );
        console.error(
          `Cannot add link ${newLink}. Err: ${error}; ${responseObj}`
        );
      });
  },

  loadIssues() {
    return this.fetch(archiveUrl, "Cannot load archived issues: ");
  },

  fetch(backendUrl, errMsg) {
    return axios({
      url: backendUrl,
      method: "GET",
      responseType: "json",
      headers: { ...Headers.auth() }
    })
      .then(response => response.data)
      .catch(response => console.log(errMsg + response));
  },

  createIssue() {
    return axios({
      url: archiveUrl,
      method: "POST",
      headers: { ...Headers.auth() }
    });
  },

  currentIssueHtml() {
    return axios({
      url: `${archiveUrl}/current`,
      method: "GET",
      headers: { ...Headers.auth() }
    })
      .then(response => response.data)
      .catch(response =>
        console.log("Unable to load HTML of current issue: " + response)
      );
  },

  loadStats() {
    return this.fetch(statsUrl, "Cannot load statistics: ");
  },

  lookupTwitterHandleForAuthor(author) {
    return axios({
      url: `${twitterHandleUrl}?author=${author}`,
      method: "GET",
      headers: {...Headers.auth()}
    })
      .then(response => response.data)
      .catch(response => console.error("Unable to find twitter handle for " + author));
  }
};



// WEBPACK FOOTER //
// ./src/common/services/http.js